// extracted by mini-css-extract-plugin
module.exports = {"loader":"ButtonLoader_loader__3qizN","rotate":"ButtonLoader_rotate__322W4","circle":"ButtonLoader_circle__4ZnJT","dash":"ButtonLoader_dash__O5iig"};